import { render, staticRenderFns } from "./LoginOptions.vue?vue&type=template&id=966acd9c"
import script from "./LoginOptions.vue?vue&type=script&lang=js"
export * from "./LoginOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports